export const LOADER_STATUS = 'boilerplate/ITC04/View/LOADER_STATUS';
export const ACTIVE_TAB = 'boilerplate/ITC04/View/ACTIVE_TAB';
export const FILE_DATA = "boilderplate/ITC04/View/FILE_DATA";
export const SET_ENTITY_LIST = 'boilderplate/ITC04/SET_ENTITY_LIST';
export const PROFILE_DATA = 'boilderplate/ITC04/PROFILE_DATA';
export const STORE_PERIOD = 'boilerplate/ITC04/STORE_PERIOD';
export const STORE_GSTIN_ITC04 = 'boilderplate/ITC04/STORE_GSTIN_ITC04';
